export const GetPasswordRegex = () => {
  return new RegExp(/^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z]).{8,32}$/);
}

export const GetVatNumberRegex = () => {
  return new RegExp(/^(|BE ?0[0-9]{9}|undefined)$/);
}

export function GetValidationNa(value: string): boolean {
  if(!value)
  {
    return false;
  }
  if(value.includes("NA"))
  {
    return true;
  }
  return GetVatNumberRegex().test(value);
}
export const GetEmailRegex = () => {
  return new RegExp(/(^((([!#$%&'*+\-/=?^_`{|}~\w])|([!#$%&'*+\-/=?^_`{|}~\w][!#$%&'*+\-/=?^_`{|}~\.\w]{0,}[!#$%&'*+\-/=?^_`{|}~\w]))[@]\w+([-.]\w+)*\.\w+([-.]\w+)*))$/);
}
